import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { MdSearch, MdAdd } from "react-icons/md";
import Button from "react-bootstrap/Button";
import editpic from "../../assets/edit.svg";
import deletepic from "../../assets/delete.svg";
import forwardpic from "../../assets/forward.svg";
import DuplicateIcon from "../../assets/CreateDuplicateIcon.svg";
import { Image, Popover } from "react-bootstrap";
import greenradio from "../../assets/green-radio.svg";
import redradio from "../../assets/red-radio.svg";
import greyradio from "../../assets/gray-radio.svg";
import orangeradio from "../../assets/orange-radio.svg";
import { format } from "date-fns";
import { useState } from "react";
import { useEffect } from "react";
import { ManageVouchersApi } from "../../Utils/Api/ManageVouchers";
import { DeleteVoucherApi } from "../../Utils/Api/DeleteVoucherApi";
import { RemoveSortkeys, userId } from "../../Utils/LocalStorage";
import sortpic from "../../assets/sort.svg";
import MyVerticallyCenteredModal from "../../Components/DeleteModal/DeleteModal";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import {
  FacebookShareButton,
  FacebookIcon,
  WhatsappShareButton,
  WhatsappIcon,
} from "react-share";
import Pagination from "../../Components/Pagination/Pagination";
import Loader from "../../Components/Loader/Loader";
import { FaSort, FaSortDown, FaSortUp } from "react-icons/fa";
import { toast } from "react-toastify";
import { LatestVouchersApi } from "../../Utils/Api/LatestVoucherList";
import SearchBarResults from "../../Components/Search/SearchBarResults";
import { ServerError } from "../../Utils/GlobalVariables/ToastifierVariables";
// import Share from "../../Components/Share/Share";

const ManageVouchersVoucherDashboard = () => {
  const [manageVouchersData, setManageVouchers] = useState([]);
  const [deleteId, setDeleteID] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [limit, setLimit] = useState(0);
  const [loading, setLoading] = useState(false);
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [search, setSearch] = useState("");

  const [flag, setFlag] = useState({
    voucher_name: 0,
    mms_city_name: 0,
    voucher_offer_price: 0,
    download_count: 0,
    redeemed_count: 0,
  });

  const shareUrl = process.env.REACT_APP_COMMON_URL + "my-account/view-voucher";

  const navigate = useNavigate();

  const uid = parseInt(userId());

  const ManageVouchersAPIHandler = async (searchVal, sortval, colName) => {
    if (colName) {
      localStorage.setItem("colName", colName);
    }
    if (sortval) {
      localStorage.setItem("sortval", sortval);
    }

    const ColName = localStorage.getItem("colName");
    const SortVal = parseInt(localStorage.getItem("sortval"));
    const val = {
      business_id: uid,
      limit: 5,
      offset: searchVal ? 0 : pageNumber,
      search_value: searchVal,
      column_name: ColName ? ColName : colName,
      sort_type: SortVal ? SortVal : sortval,
    };
    if (!val.sort_type && !val.column_name) {
      setLoading(true);
    }
    const VoucherTableData = await LatestVouchersApi(val, () => {
      navigate("/");
    });
    if (VoucherTableData === false) {
      toast.error(ServerError, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setLoading(false);
    } else if (VoucherTableData.status == 429) {
      setLoading(true);
      toast.error(VoucherTableData.message, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    } else {
      if (VoucherTableData.success === true) {
        if (!val.sort_type && !val.column_name) {
          setLoading(false);
        }
        setManageVouchers(VoucherTableData.data);
        setTotalPageCount(VoucherTableData.total_row);
        setLimit(VoucherTableData.limit);
      } else {
        setManageVouchers([]);
        setTotalPageCount(0);
        setLimit(5);
        setLoading(false);
      }
    }
  };

  const handleDelete = async (flag) => {
    if (flag === true) {
      const val = {
        business_id: uid,
        voucher_id: deleteId,
      };

      setLoading(true);
      const filteredList = await DeleteVoucherApi(val, () => {
        navigate("/");
      });
      ManageVouchersAPIHandler();
      setLoading(false);
      setModalShow(false);

      if (filteredList.success === true) {
        toast.success(filteredList.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else if (filteredList.status === 429) {
        toast.error(filteredList.message, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setLoading(true);
      } else {
        toast.error(filteredList.message, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    }
  };

  const handleChange = (e) => {
    let val = e.target.value;
    setSearch(val.trim());
    if (!val) {
      ManageVouchersAPIHandler("");
    }
  };

  const handleSearchClick = () => {
    ManageVouchersAPIHandler(search);
  };
  // enter-keyboard
  const handleKeypress = (e) => {
    if (e.code === "Enter") {
      ManageVouchersAPIHandler(search);
    }
  };

  const HandleSort = (columnValue) => {
    // voucher_name
    if (columnValue == "voucher_name") {
      if (flag.voucher_name === 0) {
        ManageVouchersAPIHandler(search, 1, "voucher_name");
        setFlag((ps) => {
          return { ...ps, voucher_name: 1 };
        });
      } else if (flag.voucher_name === 1) {
        ManageVouchersAPIHandler(search, 2, "voucher_name");
        setFlag((ps) => {
          return { ...ps, voucher_name: 2 };
        });
      } else {
        ManageVouchersAPIHandler(search, 0, "voucher_name");
        setFlag((ps) => {
          return { ...ps, voucher_name: 0 };
        });
      }
    }
    // mms_city_name
    if (columnValue == "mms_city_name") {
      if (flag.mms_city_name === 0) {
        ManageVouchersAPIHandler(search, 1, "mms_city_name");
        setFlag((ps) => {
          return { ...ps, mms_city_name: 1 };
        });
      } else if (flag.mms_city_name === 1) {
        ManageVouchersAPIHandler(search, 2, "mms_city_name");
        setFlag((ps) => {
          return { ...ps, mms_city_name: 2 };
        });
      } else {
        ManageVouchersAPIHandler(search, 0, "mms_city_name");
        setFlag((ps) => {
          return { ...ps, mms_city_name: 0 };
        });
      }
    }

    // voucher_offer_price
    if (columnValue == "voucher_offer_price") {
      if (flag.voucher_offer_price === 0) {
        ManageVouchersAPIHandler(search, 1, "voucher_offer_price");
        setFlag((ps) => {
          return { ...ps, voucher_offer_price: 1 };
        });
      } else if (flag.voucher_offer_price === 1) {
        ManageVouchersAPIHandler(search, 2, "voucher_offer_price");
        setFlag((ps) => {
          return { ...ps, voucher_offer_price: 2 };
        });
      } else {
        ManageVouchersAPIHandler(search, 0, "voucher_offer_price");
        setFlag((ps) => {
          return { ...ps, voucher_offer_price: 0 };
        });
      }
    }

    // download_count
    if (columnValue == "download_count") {
      if (flag.download_count === 0) {
        ManageVouchersAPIHandler(search, 1, "download_count");
        setFlag((ps) => {
          return { ...ps, download_count: 1 };
        });
      } else if (flag.download_count === 1) {
        ManageVouchersAPIHandler(search, 2, "download_count");
        setFlag((ps) => {
          return { ...ps, download_count: 2 };
        });
      } else {
        ManageVouchersAPIHandler(search, 0, "download_count");
        setFlag((ps) => {
          return { ...ps, download_count: 0 };
        });
      }
    }

    // redeemed_count
    if (columnValue == "redeemed_count") {
      if (flag.redeemed_count === 0) {
        ManageVouchersAPIHandler(search, 1, "redeemed_count");
        setFlag((ps) => {
          return { ...ps, redeemed_count: 1 };
        });
      } else if (flag.redeemed_count === 1) {
        ManageVouchersAPIHandler(search, 2, "redeemed_count");
        setFlag((ps) => {
          return { ...ps, redeemed_count: 2 };
        });
      } else {
        ManageVouchersAPIHandler(search, 0, "redeemed_count");
        setFlag((ps) => {
          return { ...ps, redeemed_count: 0 };
        });
      }
    }
  };

  const win = window.location.href;
  useEffect(() => {
    RemoveSortkeys();
  }, [win]);

  useEffect(() => {
    ManageVouchersAPIHandler("");
    // window.scrollTo(0, 900);
  }, [pageNumber]);

  useEffect(() => {
    ManageVouchersAPIHandler("");
  }, []);

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="manage-vou-main pt-3 pb-3">
        <p className="page-maintitle pt-2">Latest Vouchers</p>
        <div className="manage-vou">
          <InputGroup className="search-bar">
            <InputGroup.Text>
              <MdSearch />
              <Form.Control
                type="text"
                placeholder="Search"
                maxLength={200}
                onChange={handleChange}
                onKeyPress={handleKeypress}
              />
            </InputGroup.Text>
            <Form.Control />
            <Button variant="outline-secondary" onClick={handleSearchClick}>
              Search
            </Button>
          </InputGroup>
        </div>
      </div>
      <SearchBarResults SearchValue={search} />
      <div className="table-responsive-xl black-header" id="latest_Voucher">
        <table className="recentact-table mt-3 table ver-middle manage-vou-table vou-dash-Table">
          <thead>
            <tr>
              {/* <th className="radio-colors"></th> */}
              <th width="300px">
                <Button onClick={() => HandleSort("voucher_name")}>
                  Voucher Name{" "}
                  {flag.voucher_name === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.voucher_name === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>
              <th>
                <Button
                  onClick={() => HandleSort("mms_city_name")}
                  style={{ margin: "auto" }}
                >
                  Marketplace{" "}
                  {flag.mms_city_name === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.mms_city_name === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>
              <th>
                <Button
                  onClick={() => HandleSort("voucher_offer_price")}
                  style={{ marginRight: "0", gap: "0" }}
                >
                  Voucher Value{" "}
                  {flag.voucher_offer_price === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.voucher_offer_price === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>
              <th>
                <Button
                  onClick={() => HandleSort("download_count")}
                  style={{ margin: "auto", gap: "0" }}
                >
                  Sold Vouchers{" "}
                  {flag.download_count === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.download_count === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>
              <th>
                <Button
                  onClick={() => HandleSort("redeemed_count")}
                  style={{ margin: "auto" }}
                >
                  Redeemed Vouchers{" "}
                  {flag.redeemed_count === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.redeemed_count === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>

              <th style={{ textAlign: "center" }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {manageVouchersData && manageVouchersData.length > 0 ? (
              manageVouchersData?.map((item, key) => {
                return (
                  <tr>
                    <td
                      className="text-left text-limit-2 blue-underline-text"
                      title={item.voucher_name}
                    >
                      <Link to={`/my-account/view-voucher/${item.voucher_id}`}>
                        {item.voucher_name}
                      </Link>
                    </td>

                    <td style={{ textAlign: "center" }}>
                      {item.mms_city_name}
                    </td>

                    <td style={{ textAlign: "end" }}>
                      ${item.voucher_offer_price}
                    </td>

                    <td style={{ textAlign: "center" }}>{item.voucher_sold}</td>

                    <td style={{ textAlign: "center" }}>
                      {item.vouhcer_redeemed}
                    </td>

                    <td>
                      <div className={`status_bg_${item.status_name}`}>
                        {item.status_name}
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={9} className="text-center">
                  <p className="no-record">No records available!</p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div>
        {totalPageCount > 5 ? (
          <Pagination
            TotalPageCount={totalPageCount}
            Limit={limit}
            SetPageNumber={setPageNumber}
          />
        ) : (
          <></>
        )}
      </div>
      <MyVerticallyCenteredModal
        handleDeletefuc={handleDelete}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default ManageVouchersVoucherDashboard;
